// App
export const INIT = "init";
export const FETCH = "fetch";
export const GET = "get";
export const CREATE = "create";
export const UPDATE = "update";
export const REMOVE = "remove";
export const LISTEN = "listen";
export const RESPOND = "respond";

// Modals
export const OPEN_MODAL_ADD = "openModalAdd";
export const CLOSE_MODAL_ADD = "closeModalAdd";

// Auth
export const LOGIN = "login";
export const LOGIN_ACCOUNT = "loginAccount";
export const RESET_PASSWORD = "resetPassword";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const CHECK_AUTH = "checkAuth";
export const GET_AUTH = "getAuth";
export const GET_AUTH_TEMPORARY = "getAuthTemporary";
export const UPDATE_AUTH = "updateAuth";
export const UPDATE_AUTH_SEEN = "updateAuthSeen";
export const UPDATE_AUTH_STATE = "updateAuthState";
export const UPDATE_AUTH_WALLET = "updateAuthWallet";
export const UPDATE_AUTH_ONBOARDING = "updateAuthOnboarding";
export const FETCH_AUTH_NFTS = "fetchAuthNfts";
export const CONNECT_TO_METAMASK = "connectToMetamask";
export const BAN_USER = "banUser";

// Channels
export const FETCH_CHANNELS = "fetchChannels";
export const CREATE_CHANNEL = "createChannel";
export const GET_CHANNEL = "getChannel";
export const GOTO_CHANNEL = "goToChannel";

// Topics
export const FETCH_TOPICS = "fetchTopics";
export const CREATE_TOPIC = "createTopic";
export const UPDATE_TOPIC = "updateTopic";
export const REMOVE_TOPIC = "removeTopic";
export const GET_TOPIC = "getTopic";
export const GET_TOPIC_BY_ID = "getTopicById";
export const CREATE_REACTION = "createReaction";
export const REMOVE_REACTION = "removeReaction";
export const GET_REACTION_BY_MSGID = "getReactionByMsgId";
export const UPDATE_USER_READING = "updateUserReading";
export const UPDATE_USER_REPLAY = "updateUserReply";
export const UPDATE_OPEN_COMMENT_EDIT = "udpateOpenCommentEdit";
export const UPDATE_QUERY_RESULT = "updateQueryResult";

//Comment
export const CREATE_COMMENT = "createComment";
export const UPDATE_COMMENT = "updateComment";
export const REMOVE_COMMENT = "removeComment";
export const GET_COMMENT = "getComment";
export const GET_COMMENT_BY_ID = "getCommentById";

//SubComment
export const CREATE_SUBCOMMENT = "createSubComment";
export const UPDATE_SUBCOMMENT = "updateSubComment";
export const REMOVE_SUBCOMMENT = "removeSubComment";
export const GET_SUBCOMMENT_BY_ID = "getSubCommentById";

// Members
export const GET_MEMBER = "getMember";
export const GET_MEMBER_BY_ID = "getMemberById";
export const FETCH_MEMBERS_ONLINE = "fetchMembersOnline";
export const FETCH_MEMBERS_BY_CHANNEL_ID = "fetchMembersByChannelId";
export const FETCH_MEMBERS_TOTAL = "fetchTotalMembers";

// Trainings
export const FETCH_TRAININGS = "fetchTrainings";
export const CREATE_TRAINING = "createTraining";
export const GET_TRAINING = "getTraining";

// Lessons
export const CREATE_LESSON = "createLesson";

// World
export const FETCH_WORLDS = "fetchWorlds";
export const CREATE_WORLD = "addWorld";
export const GET_WORLD = "getWorld";
export const UPDATE_WORLD = "updateWorld";
export const TELEPORTTO_WORLD = "teleportToWorld";
export const MINT_WORLD = "mintWorld";
export const GOTO_WORLD = "goToWorld";
export const TELEPORT_NEW_PLAYER = "teleportNewPlayer";
export const MOVE_PLAYER = "movePlayer";

// Files
export const GET_FILE = "getFile";
export const UPLOAD_FILE = "uploadFile";
export const UPLOAD_METADATA = "uploadMetadata";

//Numberologie
export const CHANGE_CURRENT_STEP_IN_NUMEROLOGIE = "changeCurrentStepInNumerologie";
export const CHANGE_CLIENT_DATA_IN_NUMEROLOGIE = "changeClientDataInNumerologie";
export const FETCH_AUDIO_FILES_IN_NUMEROLOGIE = "fetchAudioFilesInNumerologie";

//Common
export const SHOW_CONFIRM_DIALOG = "showConfirmDialog";
export const SHOW_DELETE_TOAST = "showDeleteToast";
export const CHANGE_EXPAND_MENU = "changeExpandMenu";
export const VIEW_USER_PROFILE = "viewUserProfile";

//Notification
export const FETCH_NOTIFICATIONS = "fetchNotifications";
export const REMOVE_NOTIFICATION = "removeNotification";
export const READ_NOTIFICATION = "readNotification";
export const GET_UNREAD_NOTIFICATION = "getUnreadNotification";

//Room
export const CREATE_ROOM = "createRoom";
export const FETCH_ROOMS = "fetchRooms";
export const FETCH_MESSAGES_IN_ROOM = "fetchMessageInRoom";
export const SEND_MESSAGE_IN_ROOM = "sendMessageInRoom";
export const UPDATE_MESSAGE_IN_ROOM = "updateMessageInRoom";
export const DELETE_MESSAGE_IN_ROOM = "deleteMessageInRoom";
export const UPDATE_UNREAD_COUNT_IN_ROOM = "updateUnreadCountInRoom";
export const LOGIN_ROOM = "loginRoom";

//private message
export const CREATE_CHAT_CHANNEL = "createChatChannel";
export const DELETE_CHAT_CHANNEL = "deleteChatChannel";
export const FETCH_CHAT_CHANNEL = "fetchChatChannel";
export const SEND_MESSAGE_IN_CHAT = "sendMessageInChat";
export const UPDATE_MESSAGE_IN_CHAT = "updateMessageInChat";
export const FETCH_MESSAGES_IN_CHAT = "fetchMessagesInChat";
export const DELETE_MESSAGE_IN_CHAT = "deleteMessageInChat";
export const UPDATE_UNREAD_COUNT_IN_CHAT = "updateUnreadCountInChat";
export const UPDATE_META_INFO_IN_CHAT = "updateMetaInformationInChat";

// Leads
export const CREATE_LEAD = "createLead";

// Minting
export const MINT_GLADIATEUR = "mintGladiateur";
export const FETCH_NFTS_OWNER = "fetchNftsOwner";
export const FETCH_MOUTRUGEONS = "fetchMoutrugeons";

// Numerology
export const GENERATE_NUMEROLOGY_PDF = "generateNumerologyPdf";
export const GENERATE_NUMEROLOGY_MANDALA = "generateNumerologyMandala";

// Stripe
export const STRIPE_INIT_CHECKOUT = "stripeInitCheckout";

// Mailing
export const SEND_EMAIL = "sendEmail";
